import { render, staticRenderFns } from "./PromotionECouponAuto.vue?vue&type=template&id=4b06958e&scoped=true&"
import script from "./PromotionECouponAuto.vue?vue&type=script&lang=js&"
export * from "./PromotionECouponAuto.vue?vue&type=script&lang=js&"
import style0 from "./PromotionECouponAuto.vue?vue&type=style&index=0&id=4b06958e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06958e",
  null
  
)

export default component.exports